import { Box, Button, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  getExternalReferrals,
  getExternalReferralsReport,
} from "../../api/group";
import { getGroupAreas, getGroupTrips } from "../../api/jahadgar";
import CustomizedHook from "../../components/project/autocomplatePro";
import TableErja from "./tableErja";

export default function Erja() {
  const [dataUsers, setDataUsers] = useState();
  const [DataAreas2, setDataAreas2] = useState();
  const [areaId, setAreaId] = useState();
  const [tripsId, setTripsId] = useState();
  const [dataGroup, setDataGroup] = useState();

  const [loading, setLoading] = useState(false);
  const [pageable, setPageable] = useState();
  const [totalSize, setTotalSize] = useState();

  useEffect(() => {
    getGroupTrips()
      .then((x) => {
        setDataGroup(x);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (tripsId) {
      getGroupAreas(`?tripId=${tripsId}`)
        .then((x) => {
          setDataAreas2(x);
        })
        .catch(() => {});
    }
  }, [tripsId]);

  const fetchPatients = useCallback(() => {
    setLoading(true);
    setDataUsers([]);
    getExternalReferrals(
      areaId,
      pageable.pageIndex,
      pageable.pageSize,
      totalSize === undefined,
    )
      .then((x) => {
        setDataUsers(x.patients);
        if (totalSize === undefined) setTotalSize(x.totalSize);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageable, totalSize, areaId]);

  useEffect(() => {
    if (areaId && pageable) {
      fetchPatients();
    }
  }, [areaId, pageable]);

  return (
    <>
      <Box>
        <Grid
          mt={"20px"}
          display={"flex"}
          flexDirection={"row"}
          gap="30px"
          alignItems={"end"}
        >
          <CustomizedHook
            width={"220px"}
            parentWidth={"220px"}
            placeholder={"انتخاب کنید."}
            label="نام اردو"
            options={
              // notGroup ? dataGroup :
              dataGroup
            }
            onChange={(_, newValue) => {
              setTripsId(newValue.id);
            }}
          />
          <CustomizedHook
            width={"220px"}
            parentWidth={"220px"}
            placeholder={"انتخاب کنید."}
            label="نام منطقه"
            options={DataAreas2}
            onChange={(_, newValue) => {
              setAreaId(newValue.id);
            }}
            //   value={
            //     countries.find((country) => country.name === stepOne.country) ||
            //     dataLoc?.countries ||
            //     null
            //   }
          />

          <Button
            sx={{
              bgcolor: "var(--emr-primary)",
              color: "white",
              width: "220px",
              ":hover": {
                bgcolor: "var(--emr-darkblue)",
              },
            }}
            onClick={() => {
              if (areaId) {
                setPageable({
                  pageIndex: 0,
                  pageSize: 10,
                });
              }
            }}
          >
            مشاهده بیماران ارجاع شده
          </Button>
          {dataUsers && (
            <Button
              variant="contained"
              sx={{
                width: "220px",
              }}
              onClick={() => {
                if (areaId) {
                  getExternalReferralsReport(areaId)
                    .then((x) => {
                      const blob = new Blob([x], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = "گزارش ارجاع خارجی.xlsx";
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      window.URL.revokeObjectURL(url);
                    })
                    .catch(() => {});
                }
              }}
            >
              دانلود فایل اکسل گزارش
            </Button>
          )}
        </Grid>

        {dataUsers && (
          <TableErja
            refetching={loading}
            pageable={pageable}
            totalElements={totalSize}
            setPageable={setPageable}
            areaId={areaId}
            rowData={dataUsers}
          />
        )}
      </Box>
    </>
  );
}
